export enum Function {
  department = 'department',
  establishment = 'establishment',
}
